import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ActivityFilterDialog: LoadableType<{
	onClose: () => void;
	onChanged: () => void;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ActivityFilterDialog" */ '../src/ActivityFilterDialog.tsx'
			)
		).ActivityFilterDialog,
});
